import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  h1 {
    line-height: normal;
  }

  button {
    align-self: flex-end;
  }
`

export const Inputs = styled.div`
  display: flex;
  gap: 16px;

  div {
    width: 100%;
    max-width: 380px;
  }
`

export const Buttons = styled.div`
  display: flex;

  justify-content: flex-end;
  button:last-child {
    margin-left: 10px;
  }
`

export const AddPatient = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 500px;

  & div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.font.sizes.small};
    & svg {
      width: 14px;
      height: 14px;
      margin-right: 4px;

      & path {
        fill: ${({ theme }) => theme.colors.primary};
        stroke: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`

export const SearchInputWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 12px;
  position: relative;
  max-width: 330px;
`

export const NotFoundPatientMessage = styled.div`
  display: flex;
`
